<p-dialog [(visible)]="visible" [showHeader]="false" [modal]="true">
    <div class="wrapper">
        <div>
            <div class="modal-header">
                <h4 class="modal-title"><strong>Bestätigung</strong></h4>
            </div>
            <div class="modal-body">
                <form id="form" [formGroup]="formular" (ngSubmit)="anmeldungSpeichern()">
                    <div>Bitte wählen Sie den Typ Ihrer Zertifizierung aus:
                        <p-dropdown *ngIf="!istZertifizierung && !istRezertifizierung" id="zertifizierungstyp" formControlName="zertifizierungstyp" [options]="zertifizierungstypOptionen"/>
                        <p-dropdown *ngIf="istZertifizierung" formControlName="zertifizierungstyp" [(ngModel)]="selectedTyp" [options]="zertifizierung"/>
                        <p-dropdown *ngIf="istRezertifizierung" formControlName="zertifizierungstyp" [(ngModel)]="selectedTyp" [options]="rezertifizierung"/>
                        <div class="invalid-input"
                             [hidden]="formular.controls.zertifizierungstyp.valid || formular.controls.zertifizierungstyp.untouched">
                            Bitte geben Sie Ihren Zertifizierungstyp an.
                        </div>
                    </div>

                    <div *ngIf="zeigeGutachtertaetigkeiten">
                        <br>
                        Ihre Gutachtertätigkeit für (Mehrfachauswahl möglich):
                        <p-listbox formControlName="gutachterTaetigkeit" [multiple]="true"
                                   [options]="gutachterTaetigkeitOptionen"/>
                    </div>

                    <br>
                    <div>
                        <p>
                            Wollen Sie sich verbindlich für die Veranstaltung
                            <strong>"{{ titel(kurs.typ!) }}"</strong> anmelden?
                        </p>
                    </div>

                    <p class="alert alert-info">
                        <fa-icon [icon]="['fas', 'info-circle']" aria-hidden="true"></fa-icon>
                        Bitte beachten Sie, dass bei einer späteren Abmeldung Stornokosten in der Höhe von bis zu
                        100%
                        der Teilnahmegebühr entstehen können.
                    </p>

                    <div id="bestaetigung_agb">
                        <div class="form-group">
                            <div class="checkbox">
                                <label>
                                    <p-checkbox formControlName="bestaetigungAGB" [binary]="true"></p-checkbox>
                                    <span>Ich habe die <a routerLink="/agb" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und stimme ihnen zu.</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div id="bestaetigung_datenschutz">
                        <div class="form-group">
                            <div class="checkbox">
                                <label>
                                    <p-checkbox formControlName="bestaetigungDatenschutz" [binary]="true"></p-checkbox>
                                    <span>Ich habe die <a routerLink="/datenschutz" target="_blank">Datenschutzerklärung</a>
                                gelesen und nehme sie zur Kenntnis</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div id="bestaetigung_traeger" *ngIf="isAUVA">
                        <div class="form-group">
                            <div class="traeger">
                                <div class="traeger-checkbox">
                                    <label>
                                        <p-checkbox formControlName="bestaetigungTraeger" [binary]="true"></p-checkbox>
                                    </label>
                                </div>
                                <div>
                                    Ich bestätige, dass der Träger für den ich begutachte bzw.
                                    begutachten werde, sein schriftliches Einverständnis zur Teilnahme an dem Lehrgang
                                    erteilt hat.
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="closeOverlay()">Abbrechen</button>
                <button type="submit" class="btn btn-success" [disabled]="formular.invalid"
                        (click)="anmeldungSpeichern()">
                    Verbindlich Anmelden
                </button>
            </div>
        </div>
    </div>
</p-dialog>
